import { ToLocalStringPipe } from '@utils/pipes';
import { BaseFilterComponent } from './components';

type ComponentClass = new (
  toLocal: ToLocalStringPipe
) => BaseFilterComponent;

const FILTER_REGISTRY = new Map<string, ComponentClass>();

export function FilterTypeByName(name: string): ComponentClass {
  return FILTER_REGISTRY.get(name);
}

export function RegisterFilter(cls: ComponentClass): void {
  const name = new cls(null).componentName;
  FILTER_REGISTRY.set(name, cls);
}
